import CircleRightArrowIcon from './component.jsx'
export default CircleRightArrowIcon
